import useCurrentUser from "../../../hooks/use-current-user"

export const useAutoEnrollmentFeatureVisibility = () => {
    const currentUser = useCurrentUser();
    return currentUser.isAdmin;
}